import { render, staticRenderFns } from "./ValidateBusinessAddressPhone.vue?vue&type=template&id=e5175fbc&"
import script from "./ValidateBusinessAddressPhone.vue?vue&type=script&lang=js&"
export * from "./ValidateBusinessAddressPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports